// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 100%;
  background: #f2f2f2;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.031372549);
  height: 100%;
  overflow: auto;
  padding: 45px 15px 25px;
}

ion-img {
  width: 50px;
}

.title {
  font-family: Title;
  font-size: 32px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
  color: #222222;
  margin-bottom: 25px;
}

.cross {
  position: absolute;
  top: 20px;
  right: 20px;
  height: 25px;
  width: 25px;
  padding: 3px;
}

.options {
  background: white;
  border-radius: 0.5rem;
  overflow: hidden;
  margin-bottom: 4.5rem;
}

.option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 15px;
  background: #fff;
  margin-bottom: 5px;
  width: 100%;
  border-bottom: 1px solid #e8e8df;
  border-radius: 9px;
  cursor: pointer;
}
.option:last-child {
  border-bottom: none;
}
.option span {
  font-size: 1rem;
}
.option .switch {
  width: 63px;
  height: 23px;
  background: rgba(255, 255, 255, 0.3019607843);
  border: 1px solid #000000;
  border-radius: 999px;
  display: flex;
  align-items: center;
  transition: background 0.3s;
  margin-right: 15px;
}
.option .switch.active {
  background: rgba(198, 164, 117, 0.3019607843);
}
.option .switch .knob {
  width: 42px;
  height: 23px;
  background: #e8e8df;
  border: 1px solid #000000;
  border-radius: 50px;
  transform: translateX(-1px);
  transition: transform 0.3s;
}
.option .switch.active .knob {
  background: #9f7b52;
  transform: translateX(20px);
}

.footer-item {
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 20px 15px;
  display: flex;
  justify-content: center;
}
.footer-item ion-button {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/filters-modal/filters-modal.component.scss"],"names":[],"mappings":"AAKA;EACC,WAAA;EACA,mBAAA;EACA,uDAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;AAJD;;AAOA;EACC,WAAA;AAJD;;AAOA;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AAJD;;AAOA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAJD;;AAOA;EACC,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;AAJD;;AAOA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EAEA,kBAAA;EAEA,WAAA;EACA,gCAAA;EACA,kBAAA;EAEA,eAAA;AAPD;AASC;EACC,mBAAA;AAPF;AAUC;EACC,eAAA;AARF;AAWC;EACC,WAAA;EACA,YAAA;EACA,6CAAA;EACA,yBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AATF;AAWE;EACC,6CAAA;AATH;AAYE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2BAAA;EACA,0BAAA;AAVH;AAaE;EACC,mBAAA;EACA,2BAAA;AAXH;;AAeA;EACC,eAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AAZD;AAaC;EACC,WAAA;AAXF","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n}\n\n.wrapper {\n\twidth: 100%;\n\tbackground: #f2f2f2;\n\tbox-shadow: 0px 4px 10px 0px #00000008;\n\theight: 100%;\n\toverflow: auto;\n\tpadding: 45px 15px 25px;\n}\n\nion-img {\n\twidth: 50px;\n}\n\n.title {\n\tfont-family: Title;\n\tfont-size: 32px;\n\tline-height: 120%;\n\tletter-spacing: 0%;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\tcolor: #222222;\n\tmargin-bottom: 25px;\n}\n\n.cross {\n\tposition: absolute;\n\ttop: 20px;\n\tright: 20px;\n\theight: 25px;\n\twidth: 25px;\n\tpadding: 3px;\n}\n\n.options {\n\tbackground: white;\n\tborder-radius: 0.5rem;\n\toverflow: hidden;\n\tmargin-bottom: 4.5rem;\n}\n\n.option {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 12px 15px;\n\tbackground: #fff;\n\n\tmargin-bottom: 5px;\n\n\twidth: 100%;\n\tborder-bottom: 1px solid #e8e8df;\n\tborder-radius: 9px;\n\n\tcursor: pointer;\n\n\t&:last-child {\n\t\tborder-bottom: none;\n\t}\n\n\tspan {\n\t\tfont-size: 1rem;\n\t}\n\n\t.switch {\n\t\twidth: 63px;\n\t\theight: 23px;\n\t\tbackground: #ffffff4d;\n\t\tborder: 1px solid #000000;\n\t\tborder-radius: 999px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\ttransition: background 0.3s;\n\t\tmargin-right: 15px;\n\n\t\t&.active {\n\t\t\tbackground: #c6a4754d;\n\t\t}\n\n\t\t.knob {\n\t\t\twidth: 42px;\n\t\t\theight: 23px;\n\t\t\tbackground: #e8e8df;\n\t\t\tborder: 1px solid #000000;\n\t\t\tborder-radius: 50px;\n\t\t\ttransform: translateX(-1px);\n\t\t\ttransition: transform 0.3s;\n\t\t}\n\n\t\t&.active .knob {\n\t\t\tbackground: #9f7b52;\n\t\t\ttransform: translateX(20px);\n\t\t}\n\t}\n}\n.footer-item {\n\tposition: fixed;\n\tleft: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tpadding: 20px 15px;\n\tdisplay: flex;\n\tjustify-content: center;\n\tion-button {\n\t\twidth: 100%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
